const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  email: state => state.user.email,
  sentri: state => state.user.sentri,
  billing_email: state => state.user.billing_email,
  billing_rfc: state => state.user.billing_rfc,
  billing_name: state => state.user.billing_name,
  terms_accepted: state => state.user.terms_accepted,
  vehicles: state => state.vehicles.list,
  crossings: state => state.crossings.list,
  balance: state => state.user.balance,
  formattedBalance: state => state.user.formattedBalance
}

export default getters
